export const InquiryTypes = [
  { value: '0', label: 'TU012_InquiryType_0' },
  { value: '1', label: 'TU012_InquiryType_1' },
  { value: '2', label: 'TU012_InquiryType_2' },
] as const;
